import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header/Header';

const ShippingPolicy = () => {
  return (
    <>
      <Header variant="white" />
      
      <main className="min-h-screen bg-[#F7F4EF]">
        {/* Hero Section */}
        <div className="pt-32 pb-6 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-light tracking-wide text-gray-900 mb-6">
              Shipping Policy
            </h1>
            <p className="text-gray-600 font-light">
              Everything you need to know about shipping your Bodios Yak Down products
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 space-y-12">
            
            {/* Order Processing */}
            <section>
              <h2 className="text-2xl font-light text-gray-900 mb-6 pb-3 border-b border-gray-100">
                Order Processing
              </h2>
              <ul className="space-y-4 text-gray-600 font-light leading-relaxed">
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>All orders are processed and shipped within <strong className="font-medium text-gray-900">2-3 business days</strong> from our warehouse in Mongolia.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>An order confirmation email will be sent immediately after purchase, including your invoice and our terms and policies.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>Orders placed on weekends or holidays will be processed on the next business day.</span>
                </li>
              </ul>
            </section>

            {/* Delivery Prices Table */}
            <section>
              <h2 className="text-2xl font-light text-gray-900 mb-6 pb-3 border-b border-gray-100">
                Delivery Prices
              </h2>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="text-left py-4 px-4 font-medium text-gray-900 rounded-tl-lg">Shipping Region</th>
                      <th className="text-left py-4 px-4 font-medium text-gray-900">Standard</th>
                      <th className="text-left py-4 px-4 font-medium text-gray-900">Delivery Time</th>
                      <th className="text-left py-4 px-4 font-medium text-gray-900">Express</th>
                      <th className="text-left py-4 px-4 font-medium text-gray-900 rounded-tr-lg">Delivery Time</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    <tr>
                      <td className="py-4 px-4 text-gray-900 font-medium">United States</td>
                      <td className="py-4 px-4 text-gray-600">$15</td>
                      <td className="py-4 px-4 text-gray-600">7-14 Business Days</td>
                      <td className="py-4 px-4 text-gray-600">$35</td>
                      <td className="py-4 px-4 text-gray-600">3-5 Business Days</td>
                    </tr>
                    <tr className="bg-gray-50/50">
                      <td className="py-4 px-4 text-gray-900 font-medium">Europe (EU)</td>
                      <td className="py-4 px-4 text-gray-600">$12</td>
                      <td className="py-4 px-4 text-gray-600">7-14 Business Days</td>
                      <td className="py-4 px-4 text-gray-600">$30</td>
                      <td className="py-4 px-4 text-gray-600">3-5 Business Days</td>
                    </tr>
                    <tr>
                      <td className="py-4 px-4 text-gray-900 font-medium">United Kingdom</td>
                      <td className="py-4 px-4 text-gray-600">$12</td>
                      <td className="py-4 px-4 text-gray-600">7-14 Business Days</td>
                      <td className="py-4 px-4 text-gray-600">$28</td>
                      <td className="py-4 px-4 text-gray-600">3-5 Business Days</td>
                    </tr>
                    <tr className="bg-gray-50/50">
                      <td className="py-4 px-4 text-gray-900 font-medium">Asia Pacific</td>
                      <td className="py-4 px-4 text-gray-600">$18</td>
                      <td className="py-4 px-4 text-gray-600">7-14 Business Days</td>
                      <td className="py-4 px-4 text-gray-600">$40</td>
                      <td className="py-4 px-4 text-gray-600">3-5 Business Days</td>
                    </tr>
                    <tr>
                      <td className="py-4 px-4 text-gray-900 font-medium">Rest of World</td>
                      <td className="py-4 px-4 text-gray-600">$60</td>
                      <td className="py-4 px-4 text-gray-600">14-21 Business Days</td>
                      <td className="py-4 px-4 text-gray-600">$60</td>
                      <td className="py-4 px-4 text-gray-600">Up to 7 Days</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-sm text-gray-500 mt-4 italic">
                * All prices are in USD ($)
              </p>
            </section>

            {/* Delivery Method */}
            <section>
              <h2 className="text-2xl font-light text-gray-900 mb-6 pb-3 border-b border-gray-100">
                Delivery Method
              </h2>
              <ul className="space-y-4 text-gray-600 font-light leading-relaxed">
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>We partner with <strong className="font-medium text-gray-900">DHL, FedEx, and UPS</strong> for international deliveries to ensure safe and timely arrival of your products.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>A shipping confirmation email with tracking number will be sent once your order is dispatched.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>All packages are carefully packed to protect your premium yak down products during transit.</span>
                </li>
              </ul>
            </section>

            {/* Delivery Period */}
            <section>
              <h2 className="text-2xl font-light text-gray-900 mb-6 pb-3 border-b border-gray-100">
                Delivery Period
              </h2>
              <ul className="space-y-4 text-gray-600 font-light leading-relaxed">
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>Under normal circumstances, products will be packed and handed over to our logistics partner within <strong className="font-medium text-gray-900">2-3 business days</strong>.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>Standard delivery typically takes <strong className="font-medium text-gray-900">7-14 business days</strong> depending on your location.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>Express delivery is available for most destinations with delivery within <strong className="font-medium text-gray-900">3-5 business days</strong>.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>During peak seasons (holidays, special promotions), delivery times may be slightly extended.</span>
                </li>
              </ul>
            </section>

            {/* Customs and Regulations */}
            <section>
              <h2 className="text-2xl font-light text-gray-900 mb-6 pb-3 border-b border-gray-100">
                Customs and Regulations
              </h2>
              
              <div className="space-y-6">
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="font-medium text-gray-900 mb-3">United States & Canada</h3>
                  <p className="text-gray-600 font-light leading-relaxed">
                    Orders under $800 USD are typically duty-free. For orders above this amount, customs duties may apply. The quoted prices do not include import duties or taxes, which are the responsibility of the customer.
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="font-medium text-gray-900 mb-3">European Union</h3>
                  <p className="text-gray-600 font-light leading-relaxed">
                    Customers in the EU may be subject to VAT and import duties. These charges are determined by local customs authorities and must be paid by the customer before delivery.
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="font-medium text-gray-900 mb-3">Rest of World</h3>
                  <p className="text-gray-600 font-light leading-relaxed">
                    Import duties, taxes, and customs clearance fees vary by country and are the responsibility of the customer. Please check with your local customs office for more information about potential charges.
                  </p>
                </div>
              </div>

              <p className="text-sm text-gray-500 mt-6 italic">
                * Bodios Yak Down is not responsible for any customs duties, taxes, or fees incurred during the import process.
              </p>
            </section>

            {/* Tracking Your Order */}
            <section>
              <h2 className="text-2xl font-light text-gray-900 mb-6 pb-3 border-b border-gray-100">
                Tracking Your Order
              </h2>
              <ul className="space-y-4 text-gray-600 font-light leading-relaxed">
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>Once your order ships, you will receive an email with a tracking number and link to monitor your delivery.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>You can also track your order by logging into your account on our website.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>If you have any questions about your shipment, please contact our customer service team at <a href="mailto:sales@bodios.mn" className="text-gray-900 underline hover:no-underline">sales@bodios.mn</a></span>
                </li>
              </ul>
            </section>

            {/* Out of Stock */}
            <section>
              <h2 className="text-2xl font-light text-gray-900 mb-6 pb-3 border-b border-gray-100">
                Out of Stock Items
              </h2>
              <p className="text-gray-600 font-light leading-relaxed">
                If an item you ordered is out of stock, we will notify you immediately and offer the following options:
              </p>
              <ul className="space-y-4 text-gray-600 font-light leading-relaxed mt-4">
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>Wait for the item to be restocked (estimated time will be provided)</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>Choose an alternative product of equal or lesser value</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-gray-400">•</span>
                  <span>Receive a full refund for the out-of-stock item</span>
                </li>
              </ul>
            </section>

            {/* Contact */}
            <section className="bg-gray-50 rounded-xl p-8 text-center">
              <h2 className="text-xl font-light text-gray-900 mb-4">
                Questions about shipping?
              </h2>
              <p className="text-gray-600 font-light mb-6">
                Our customer service team is here to help you with any shipping inquiries.
              </p>
              <a 
                href="mailto:support@bodiosyakdown.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-black text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Contact Support
              </a>
            </section>

          </div>
        </div>

        {/* Features Banner */}
        <div className="bg-white border-t border-gray-100">
          <div className="max-w-6xl mx-auto px-4 py-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gray-50 flex items-center justify-center">
                  <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                  </svg>
                </div>
                <p className="text-sm text-gray-600 font-light">Worldwide shipping</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gray-50 flex items-center justify-center">
                  <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </div>
                <p className="text-sm text-gray-600 font-light">14-day easy returns</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gray-50 flex items-center justify-center">
                  <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <p className="text-sm text-gray-600 font-light">Secure payment</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gray-50 flex items-center justify-center">
                  <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <p className="text-sm text-gray-600 font-light">100% Made in Mongolia</p>
              </div>
            </div>
          </div>
        </div>
      </main>

    </>
  );
};

export default ShippingPolicy;